/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} InboxInputs */

const en_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

const es_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandeja de entrada`)
};

const fr_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boîte de réception`)
};

const de_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posteingang`)
};

const ja_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受信トレイ`)
};

const zh_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收件箱`)
};

const ar_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صندوق الوارد`)
};

const id_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotak Masuk`)
};

const it_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggi`)
};

const ru_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Входящие`)
};

const pt_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caixa de Entrada`)
};

const ko_inbox = /** @type {(inputs: InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수신함`)
};

/**
* | output |
* | --- |
* | "Inbox" |
*
* @param {InboxInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox = /** @type {((inputs?: InboxInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<InboxInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox(inputs)
	if (locale === "es") return es_inbox(inputs)
	if (locale === "fr") return fr_inbox(inputs)
	if (locale === "de") return de_inbox(inputs)
	if (locale === "ja") return ja_inbox(inputs)
	if (locale === "zh") return zh_inbox(inputs)
	if (locale === "ar") return ar_inbox(inputs)
	if (locale === "id") return id_inbox(inputs)
	if (locale === "it") return it_inbox(inputs)
	if (locale === "ru") return ru_inbox(inputs)
	if (locale === "pt") return pt_inbox(inputs)
	return ko_inbox(inputs)
});